import ivclass from '@invideoio/web-shared/Modules/IVClass';
import PricingPlanCard from './PricingPlanCard';
import { useContext, useState } from 'react';
import { StateContext, RedirectContext } from '@store/store';

import { AiPlan } from 'src/types/pricing.types';
import useAIPricing from '@hooks/useAIPricing';
import Shimmer from '@components/loader/Shimmer';
import { getSeatsFromCounter } from '../AiCredits';
import { sendRudderStackAnalyticEvent } from '@utils/analytics';
import {
  AnalyticsProductType,
  ClickCtaType,
  ClickCtaUxSource,
  ClickGetPlanEventProperties,
} from 'src/types/analytics.types';

interface PricingCardsProps {
  isYearlyDuration: boolean;
  goToPlanDetails?: Function;
}

const PricingCards = (props: PricingCardsProps) => {
  const { isYearlyDuration, goToPlanDetails } = props;

  const globalState = useContext(StateContext);
  const { handlePricingCardClick } = useContext(RedirectContext);

  const [_, setSectionRef] = useState<any>(null);

  const handleOnCardClick = (plan: AiPlan) => {
    const { addOnSubscriptionPlans } = globalState;
    const plan2 = isYearlyDuration
      ? addOnSubscriptionPlans.generative.yearly.plan_id
      : addOnSubscriptionPlans.generative.monthly.plan_id;
    const seats2 = getSeatsFromCounter(globalState.aiCreditsCounter[plan.key]);
    handlePricingCardClick(
      plan,
      isYearlyDuration,
      globalState.seats,
      plan2,
      seats2,
    );

    const analyticsProperties: ClickGetPlanEventProperties = {
      plan_price_id:
        plan.planPrice[isYearlyDuration ? 'yearly' : 'monthly'].planId,
      product: AnalyticsProductType.AI,
      seats: globalState.seats[plan.key] ?? -1,
      type: ClickCtaType.ClickGetPlan,
      ux_source: ClickCtaUxSource.PricingCard,
    };

    if (seats2) {
      analyticsProperties.addon_plan_price_id = plan2;
      analyticsProperties.addon_plan_seats = seats2;
    }

    sendRudderStackAnalyticEvent({
      event_name: 'click_cta',
      event_properties: analyticsProperties,
    });
  };

  const { hasPlanFetched } = useAIPricing(true);

  return (
    <>
      <div
        ref={setSectionRef}
        className={ivclass(
          'iv-flex iv-justify-center',
          'sm:iv-flex-col md:iv-flex-col pricingcollapse:iv-flex-col',
          'iv-gap-30 md:iv-gap-35 sm:iv-gap-30',
          'iv-mt-10',
          'xl:iv-pb-4',
        )}
      >
        {hasPlanFetched && Array.isArray(globalState.aiPlanData)
          ? globalState.aiPlanData.map((plan: AiPlan) => {
              return (
                <PricingPlanCard
                  key={plan.key}
                  planKey={plan.key}
                  planName={plan.name}
                  bannerText={plan.key === 'generative' ? 'Best Value' : ''}
                  planPrice={plan.planPrice}
                  isYearlyDuration={isYearlyDuration}
                  CTA={plan.CTA}
                  features={plan.key_features}
                  disabled={false}
                  goToPlanDetails={goToPlanDetails}
                  onClick={() => {
                    handleOnCardClick(plan);
                  }}
                />
              );
            })
          : Array(4)
              .fill(-1)
              .map((_, idx) => (
                <div
                  key={idx}
                  className={ivclass(
                    'iv-h-[600px] iv-w-[300px]',
                    'sm:iv-h-[300px] md:iv-w-[600px] md:iv-h-[300px]',
                  )}
                >
                  <Shimmer />
                </div>
              ))}
      </div>
    </>
  );
};

export default PricingCards;
